import { AVAILABLE_DEAL_STRUCTURE_STATUSES } from '../consts/consts';
import { IAvailableDealStructureStatus, ILoanVariables } from '../types';

/**
 * Whether the modal must prompt the dealer to resubmit for confirmed pricing.
 *
 * The backend nulls `customer_rate` when it cannot support a rate for the vehicle on screen --
 * for Ally, whenever the deal structure falls outside the ADS rate grid that priced the decision
 * (SWA-7935). The rate column is then hidden (there is no number to show), so the heading says
 * to resubmit instead.
 *
 * This only ever happens off an R1 decision (AllyPricing stands down without one, see
 * ally-pricing-requires-a-decision), and only reads as "resubmit" when the structure is otherwise
 * In Policy -- Out of Policy and Missing/Invalid already tell the dealer the deal can't be priced,
 * so the resubmit note would be redundant noise on top of that message (SWA-7959).
 *
 * `isCustomerRateEnabled` is the Show Rates / Arra deal-source gate -- whether a rate column
 * *would* be offered if the backend had a number -- not whether the column is currently rendered.
 * RAC has no root `customer_rate` and reads whatever `lenderControls` the last visited lender
 * left behind; Arra Finance in a RouteOne session enables the column on the deal vehicle
 * regardless of its Show Rates control.
 */
export const getShouldPromptResubmit = (
  isCustomerRateEnabled: boolean | undefined,
  loanVariables: ILoanVariables | null | undefined,
  availableDealStructureStatus: IAvailableDealStructureStatus,
  isRouteOneSession: boolean,
): boolean =>
  Boolean(isCustomerRateEnabled) &&
  isRouteOneSession &&
  availableDealStructureStatus === AVAILABLE_DEAL_STRUCTURE_STATUSES.IN_POLICY &&
  loanVariables?.customer_rate == null;
